<div class="subscriber-stats-and-reports">
  <h3>Subscribers</h3>
  <br />
  <div class="content">
    <div>
      <div>Current active:</div>
      <div>
        {{ channelSubscriberStats && channelSubscriberStats[0]?.totalCount }}
      </div>
    </div>
    <div *ngFor="let item of channelSubscriberStats">
      <div>Current active {{ item?.channel?.name }}:</div>
      <div>{{ item?.countPerChannel }}</div>
    </div>
  </div>
  <br />
  <div>
    <div>Reports:</div>
  </div>
</div>
